module.exports = __webpack_public_path__ + "static/media/logo.2673ac89.png";